import { useContext } from 'react'

import { ReabTypeVeichuleContext } from '@provider/Parametrization/ReabTypeVeichuleProvider'

import { IReabTypeVeichuleProvider } from '@base/@types/providers/Parametrization/ReabTypeVeichuleProvider'
export default function useReabTypeVeichule(): IReabTypeVeichuleProvider {
  const context = useContext(ReabTypeVeichuleContext)

  return context
}
